module.exports = __webpack_public_path__ + "img/Non-Active Circle.cea920dc.svg";